import React from 'react';
import If from 'src/components/Shared/If/If';
import { default as config } from 'src/config/config';
import {
  FundNoteAutoBuy,
  FundNoteAutoExchange,
  FundNoteAutoRMD,
} from 'src/settings/settings';
import { appendBasePath } from 'src/utils/nav.utils';
import FundNote from './FundNote';
import './FundNote.module.scss';
import { FundNoteListProps } from './types';

export const AutoSellFundNotes: React.VFC<FundNoteListProps> = ({ fund }) => {
  const updateLinkAMC = `${config.url}${appendBasePath('/automatic')}`;
  const updateLinkRMD = `${config.url}/usis/rmd-tool`;
  return (
    <React.Fragment>
      <If test={fund.notes[FundNoteAutoBuy.AUTO_BUY]}>
        <FundNote
          labelSubText=""
          labelText="Automatic Buy"
          tipHeader="Automatic Buy"
          tipMessage={
            <div className="exclude">
              An Automatic Buy already exists on this fund. To make changes,
              please{' '}
              <a className="exclude college-branded-link" href={updateLinkAMC}>
                edit or delete
              </a>{' '}
              your existing plan.
            </div>
          }
        />
      </If>
      <If test={fund.notes[FundNoteAutoExchange.EXISTING_RMD]}>
        <FundNote
          labelSubText=""
          labelText="Auto-RMD in Progress"
          tipHeader="Auto-RMD in Progress"
          tipMessage={
            <div className="exclude">
              You are unable to set-up a systematic out of this account due to
              an existing required minimum distribution. To edit or delete your
              Auto-RMD,{' '}
              <a
                className="exclude college-branded-link"
                href={`${config.url}/usis/rmd-tool`}
              >
                click here
              </a>
              .
            </div>
          }
        />
      </If>
      <If test={fund.notes[FundNoteAutoBuy.AUTO_SELL]}>
        <FundNote
          labelSubText=""
          labelText="Automatic Sell"
          tipHeader="Automatic Sell"
          tipMessage={
            <div className="exclude">
              An Automatic Sell exists on this fund. To make changes,{' '}
              <a className="exclude college-branded-link" href={updateLinkAMC}>
                edit or delete
              </a>{' '}
              your existing plan.
            </div>
          }
        />
      </If>
      <If test={fund.notes[FundNoteAutoRMD.AUTO_RMD]}>
        <FundNote
          labelSubText=""
          labelText="Auto RMD"
          tipHeader="Auto RMD"
          tipMessage={
            <div className="exclude">
              A custom Auto RMD exists on this fund. To make changes,{' '}
              <a className="exclude college-branded-link" href={updateLinkRMD}>
                edit or delete
              </a>{' '}
              your existing plan to proportionate.
            </div>
          }
        />
      </If>
      <If test={fund.notes[FundNoteAutoBuy.AUTO_EXCHANGE]}>
        <FundNote
          labelSubText=""
          labelText="Automatic Exchange"
          tipHeader="Automatic Exchange"
          tipMessage={
            <div className="exclude">
              An Automatic Exchange exists on this fund. To make changes,{' '}
              <a className="exclude college-branded-link" href={updateLinkAMC}>
                edit or delete
              </a>{' '}
              your existing plan.
            </div>
          }
        />
      </If>
    </React.Fragment>
  );
};
